import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "DirectionalSignLeft.svg",
  "use": "DirectionalSignLeft.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"DirectionalSignLeft.svg\"><path d=\"M45.9839,30H19.6a3.5,3.5,0,0,1-2.4751-1.0251l-4.5629-4.5607a2,2,0,0,1,0-2.8285l4.5629-4.5606A3.5008,3.5008,0,0,1,19.6,16h26.384a2,2,0,0,1,2.0006,2V28A2,2,0,0,1,45.9839,30ZM33.9993,14H29.9986a1,1,0,0,1-1-1V10a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2v3A1,1,0,0,1,33.9993,14ZM29.9986,32h4.0007a1,1,0,0,1,1,1V54a2,2,0,0,1-2,2h-2a2,2,0,0,1-2-2V33A1,1,0,0,1,29.9986,32Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol